export default "__VITE_ASSET__bMRwQc6K__"